import { useEffect, useMemo, useRef, useState } from 'react'
import { startOfDay, getDay, convertTimezoneToLocal } from '@chilipiper/date-time'
import { fillCalendarDays } from '../../../context/helpers'

const WEEK_DAYS = 7

export const useCalendar = (
  timezone: string,
  slots: string[] = [],
  daysLoaded: number = WEEK_DAYS
) => {
  const { current: loadedWeeks } = useRef<Set<number>>(new Set([Math.ceil(daysLoaded / WEEK_DAYS)]))
  const [selectedDay, setSelectedDay] = useState(new Date())
  const handleSelectDay = (day: Date) => {
    setSelectedDay(day)
  }

  useEffect(() => {
    if (slots.length > 0) {
      setSelectedDay(convertTimezoneToLocal(slots[0], timezone))
    }
  }, [slots, timezone])

  const availableDays = useMemo(
    () =>
      slots.reduce((days, slot) => {
        const parsedDate = convertTimezoneToLocal(slot, timezone)
        const day = startOfDay(parsedDate).toISOString()
        if (!days.includes(day)) {
          days.push(day)
        }
        return days
      }, [] as string[]),
    [slots, timezone]
  )

  const [firstDayAvailable] = availableDays
  const initialDay = firstDayAvailable ? new Date(firstDayAvailable) : new Date()
  const [lastWeekLoaded] = [...loadedWeeks].slice(-1)

  const initialDayIndex = getDay(initialDay) + 1
  const availabilityRange = lastWeekLoaded * WEEK_DAYS - initialDayIndex

  const isAvailableDay = validateDayAvailability(availableDays)
  const calendarDays = fillCalendarDays(initialDay, availabilityRange, isAvailableDay)

  return { calendarDays, selectedDay, loadedWeeks, handleSelectDay }
}

const validateDayAvailability = (availableDays: string[]) => (day: Date) => {
  const checkedDay = startOfDay(day).toISOString()
  return availableDays.includes(checkedDay)
}
